import { Group, RingProgress, Text } from "@mantine/core"
import { useMemo } from "react"

import { LibraryResponses } from "@tfg/types/endpoints/library"

interface Props {
  contact: LibraryResponses.SupplierDetails
}

export const SupplierListProgressBar = ({ contact: c }: Props) => {
  const ratio = useMemo(() => {
    const completed =
      (c.traceability?.completedRequests || 0) +
      (c.txCertificate?.completedRequests || 0) +
      (c.scopeCertificate?.completedRequests || 0) +
      (c.prodSiteRequestStats?.completedRequests || 0)

    const total =
      (c.traceability?.totalRequests || 0) +
      (c.txCertificate?.totalRequests || 0) +
      (c.scopeCertificate?.totalRequests || 0) +
      (c.prodSiteRequestStats?.totalRequests || 0)
    if (total === 0) return 0
    const ratio: number | undefined = Math.round((completed / total) * 100)
    return ratio
  }, [c])

  return (
    <Group wrap="nowrap">
      <RingProgress
        rootColor="gray.3"
        sections={[{ value: ratio, color: "green" }]}
        label={
          <Text fw={700} ta="center" size="xl">
            {ratio}%
          </Text>
        }
      />
    </Group>
  )
}
